// extracted by mini-css-extract-plugin
module.exports =  {"container":"mAjhH_JKajLyXTD373fD","info":"IhNya8vcCUePmhEBaQSa"};